import {ChangeDetectionStrategy, Component} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('LukkMatDrawerKnappKomponent');

/**
 * Knapp som lukker mat-drawer.
 * Kaller må sørge for å lytte til click og selv lukke draweren.
 */
@Component({
    selector: 'lukk-mat-drawer-knapp',
    templateUrl: 'lukk-mat-drawer-knapp.html',
    styleUrl: 'lukk-mat-drawer-knapp.scss',
    imports: [
        MatIcon,
        MatIconButton,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LukkMatDrawerKnappKomponent {

}
